import { useManuallyFreezeTransactionMutation } from '@/store/api/services/transactions/transactions';
import { type ModalChildrenProps, useModal } from '@bitstopco/bitstop-theme';
import { LoadingButton } from '@mui/lab';
import { Button, DialogActions, DialogContent, Divider, Typography } from '@mui/material';
import { useState } from 'react';
import toast from 'react-hot-toast';

const FreezeTransaction = ({ hide, props }: ModalChildrenProps) => {
  const { show } = useModal();
  const [manuallyFreezeTransaction, { isLoading }] = useManuallyFreezeTransactionMutation();

  const data = useState(props)[0];

  const handleBack = () => {
    hide();
    show('transaction-details', {
      data: {
        id: data.id,
      },
    });
  };

  const handleSubmit = async () => {
    try {
      await manuallyFreezeTransaction(data.id).unwrap();
      toast.success('Transaction was frozen successfully');
      hide();
    } catch (error: any) {
      toast.error(error?.data?.error?.name ?? 'Failed to freeze transaction');
    }
  };

  return (
    <>
      <DialogContent sx={{ my: 2 }}>
        <Typography variant="body2" color="text.primary" fontSize={16}>
          Are you sure you want to freeze this transaction?
        </Typography>
        <Typography variant="body2" color="text.secondary" fontSize={16}>
          Freezing this transaction will prevent the bitcoin from being sent to the user.
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button onClick={handleBack}>Back to details</Button>
        <LoadingButton
          variant="contained"
          loading={isLoading}
          disabled={isLoading}
          onClick={handleSubmit}
          data-test="freeze-transaction-confirm-button"
        >
          Yes, freeze
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default FreezeTransaction;
